// extracted by mini-css-extract-plugin
module.exports = {"addButton":"tabsStyles_addButton__2YoKr","select":"tabsStyles_select__2I5O9","search":"tabsStyles_search__yFAfQ"};